import { DocumentItem } from "./hooks/useDocumentManagement";
import { DocumentListItem } from "./DocumentListItem";
import { EmptyDocumentState } from "./EmptyDocumentState";

interface DocumentListProps {
  documents: DocumentItem[];
  dataView?: boolean;
  onNoteChange: (id: string, note: string) => void;
  onDelete: (id: string) => void;
}

export const DocumentList = ({
  documents,
  dataView = false,
  onNoteChange,
  onDelete
}: DocumentListProps) => {
  if (documents.length === 0) {
    return <EmptyDocumentState />;
  }

  return (
    <div className="tw-space-y-1 tw-border-t tw-border-border tw-pt-4">
      {documents.map(doc => (
        <DocumentListItem
          key={doc.id}
          doc={doc}
          dataView={dataView}
          onNoteChange={onNoteChange}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
